module.exports = __webpack_public_path__ + "static/media/chicken_korma.d1d20294.jpeg";